import mapReviews from '@commons/models/Reviews';
import ServiceResponse from './models/ServiceResponse';
import { format } from '../utils/string';
import { getShopReviewsURL } from './urls/apiGatewayURLs';

const DEFAULT_DAYS = 180;
const DEFAULT_PAGE = 1;
const DEFAULT_MAX = 50;
const DEFAULT_OCCASION = 'DELIVERY';

export async function fetchShopReviews({
  axios,
  shopId,
  max = DEFAULT_MAX,
  occasion = DEFAULT_OCCASION,
  isJoker = false,
  businessType,
}) {
  try {
    if (!shopId)
      return new ServiceResponse({
        error: 'shopId is a required param',
      });

    const query = `?page=${DEFAULT_PAGE}&size=${max}&occasion=${occasion}&isJoker=${isJoker}&days=${DEFAULT_DAYS}&businessType=${businessType}`;

    const url = `${format(getShopReviewsURL, shopId)}${query}`;
    const { data } = await axios.get(url);
    return new ServiceResponse({
      data: mapReviews(data),
    });
  } catch (error) {
    return new ServiceResponse({
      error,
    });
  }
}
